module.exports = __webpack_public_path__ + "img/cardio.1477eb59.jpg";